import baseUrl from "../config/baseUrl";

// Full-document OCR JSON: extracts every page of the PDF (one OCR call per
// page) and stores it in ocr_data.ocr_full_data. Started in the background
// after a successful Perform OCR / Re-OCR.
const processOcrFullData = async ({ token, documentId, file }) => {
  try {
    const formData = new FormData();
    formData.append("file", file, "document.pdf");
    formData.append("document_id", documentId);

    const response = await fetch(`${baseUrl}/api/process-ocr-full-data`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return error;
  }
};

export default processOcrFullData;
